import { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import withComponentName from '../../../../../../../decorators/withComponentName';

import Styles from './style.module.scss';

const cx = classNames.bind(Styles);

export class PricingPlansPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeType: 'quarter',
    };
  }

  scrollToForm(e) {
    e.preventDefault();

    document.querySelector('#contactus-form').scrollIntoView({
      behavior: 'smooth',
    });
  }

  formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  render() {
    const {
      priceMonthly,
      priceAnnually,
      fromContent,
      contactUs,
      isQuarterly,
    } = this.props;
    const { activeType } = this.state;

    return (
      <div className={cx('prices__container', { fromContent })}>
        <div className={cx('prices')}>
          <div className={cx('price-type', { active: activeType === 'quarter' })} onClick={() => { this.setState({ activeType: 'quarter' }); }}>
            <span className={cx('amount__content')}>
              <span className={cx('amount__time')}>
                {isQuarterly ? 'Quarterly' : 'semi-annually'}
              </span>
              <span className={cx('amount--big')}>
                <span className={cx('amount__price')}>
                  $
                  {this.formatPrice(priceMonthly)}
                  {' '}
                  US/mo
                </span>
              </span>
              <span className={cx('amount--small')}>
                Billed at
                $
                {this.formatPrice(priceMonthly * (isQuarterly ? 3 : 6))}
                {' '}
                US
                {' '}
              </span>
            </span>
          </div>

          <div className={cx('price-type', { active: activeType === 'annual' })} onClick={() => { this.setState({ activeType: 'annual' }); }}>
            <span className={cx('amount__content')}>
              <span className={cx('amount__time')}>
                Annually
              </span>
              <span className={cx('amount--big')}>
                <span className={cx('amount__price')}>
                  $
                  {this.formatPrice(priceAnnually / 12)}
                  {' '}
                  US/mo
                </span>
              </span>
              <span className={cx('amount--small')}>
                Billed at
                $
                {this.formatPrice(priceAnnually)}
                {' '}
                US
                {' '}
              </span>
            </span>
          </div>
        </div>

        {contactUs && (
          <span
            className={cx('contact-us')}
            onClick={this.scrollToForm}
          >
            Contact Us
          </span>
        )}
      </div>
    );
  }
}

PricingPlansPrice.defaultProps = {
  fromContent: false,
  contactUs: false,
  isQuarterly: false,
};

PricingPlansPrice.propTypes = {
  priceMonthly: PropTypes.string.isRequired,
  priceAnnually: PropTypes.string.isRequired,
  fromContent: PropTypes.bool,
  contactUs: PropTypes.bool,
  isQuarterly: PropTypes.bool,
};

export default withComponentName(PricingPlansPrice);
